import React from "react"
import {
  OverviewFeedAccumulationActualListScreen,
  OverviewHarvestAccumulationWeightActualListScreen,
  OverviewSellingPricePredictionListScreen,
  OverviewSurvivalRatePredictionListScreen,
  OverviewTotalWeightPredictionListScreen,
} from "../../../screens/home/overview"
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs"
import { Text } from "../../../components"
import { translate } from "../../../i18n"
import { color, nativeBaseTheme } from "../../../theme"
import { Appearance, ViewStyle } from "react-native"
import { useStores } from "../../../models"

const TAB: ViewStyle = {
  width: 'auto',
  paddingHorizontal: 32,
  paddingVertical: 8
}

export type HomeOverviewNavigatorParamList = {
  'Home.Overview.TotalWeightPrediction.List': undefined,
  'Home.Overview.HarvestAccumulationWeightActual.List': undefined,
  'Home.Overview.FeedAccumulationActual.List': undefined,
  'Home.Overview.SurvivalRatePrediction.List': undefined,
  'Home.Overview.SellingPricePrediction.List': undefined,
}

const Tab = createMaterialTopTabNavigator<HomeOverviewNavigatorParamList>()

export const OverviewStack = {
  index: 0,
  routes: [
    { name: 'Overview.Stack', state: { index: 0, routes: [{ name: 'Home.Overview.TotalWeightPrediction.List' }] } }
  ]
};

export const OverviewNavigator = () => {
  const colorScheme = "light" || Appearance.getColorScheme()
  const { appStore: { farmStore: { farm } } } = useStores()
  const isOwner = farm?.farm_user_role_id === 3;
  return (
    <Tab.Navigator
      screenOptions={{
        tabBarActiveTintColor: colorScheme === 'light' ? color.primary : undefined,
        tabBarScrollEnabled: true,
        tabBarItemStyle: TAB,
        lazy: true,
        lazyPreloadDistance: 1
      }}
    >
      <Tab.Screen
        name="Home.Overview.TotalWeightPrediction.List"
        component={OverviewTotalWeightPredictionListScreen}
        options={{
          title: translate('overviewTotalWeightPredictionListScreen.title'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="overviewTotalWeightPredictionListScreen.title"
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Overview.HarvestAccumulationWeightActual.List"
        component={OverviewHarvestAccumulationWeightActualListScreen}
        options={{
          title: translate('overviewHarvestAccumulationWeightActualListScreen.title'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="overviewHarvestAccumulationWeightActualListScreen.title"
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Overview.FeedAccumulationActual.List"
        component={OverviewFeedAccumulationActualListScreen}
        options={{
          title: translate('overviewFeedAccumulationActualListScreen.title'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="overviewFeedAccumulationActualListScreen.title"
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Overview.SurvivalRatePrediction.List"
        component={OverviewSurvivalRatePredictionListScreen}
        options={{
          title: translate('overviewSurvivalRatePredictionListScreen.title'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="overviewSurvivalRatePredictionListScreen.title"
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      {isOwner && (
        <Tab.Screen
          name="Home.Overview.SellingPricePrediction.List"
          component={OverviewSellingPricePredictionListScreen}
          options={{
            title: translate('overviewSellingPricePredictionListScreen.title'),
            tabBarLabel({ color, focused }) {
              return <Text
                tx="overviewSellingPricePredictionListScreen.title"
                preset="title4"
                colorScheme={colorScheme}
                color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
              />
            }
          }}
        />
      )}
    </Tab.Navigator>
  )
}
